import { render, staticRenderFns } from "./PreguntasFisiatria.vue?vue&type=template&id=16f9d12e"
import script from "./PreguntasFisiatria.vue?vue&type=script&lang=js"
export * from "./PreguntasFisiatria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports